export const LOCAL_STORAGE_KEY = 'closed-marketing-notifications';
const TTL_MILLISECONDS = 60 * 24 * 30 * 60000; // 30 days in milliseconds
export const getObjectToStore = (id) => ({
    id,
    ttl: Date.now() + TTL_MILLISECONDS,
});
export const getClosedNotificationsData = () => {
    try {
        const storedValue = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (storedValue) {
            return JSON.parse(storedValue);
        }
        return [];
    }
    catch (_a) {
        console.warn(`Can't retrieve  ${LOCAL_STORAGE_KEY} from localStorage`);
        return;
    }
};
export const setClosedNotificationsData = (id) => {
    const data = getClosedNotificationsData();
    try {
        const objectToStore = getObjectToStore(id);
        data.push(objectToStore);
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
    }
    catch (_a) {
        console.warn(`Can't write ${LOCAL_STORAGE_KEY} ${id} to localStorage`);
    }
};
/* cleanup function for removing the notifications data from the store that has already expired */
export const cleanUpClosedNotificationStorage = (data) => {
    const nonExpiredNotifications = data.filter((item) => item.ttl >= Date.now());
    // replace data in localStorage as we store all the data in the one key
    if (nonExpiredNotifications.length !== data.length) {
        try {
            data.splice(0, data.length, ...nonExpiredNotifications);
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
        }
        catch (_a) {
            console.warn(`Can't write ${LOCAL_STORAGE_KEY} to localStorage`);
        }
    }
};
